module.exports = __webpack_public_path__ + "static/media/group_trainings_dancing_somatic_movement.93f82a45.webp";